import api from './api';
import { API_URL } from './base';

export const fetchPartnerOptions = async country => {
    return api.get(`${API_URL}/admin/partners-list/`).then(resp => {
        return resp.data;
    });
};

export const updateAdminPartnerMapping = async (data) => {
    return api.post(`${API_URL}/admin/user-settings/set-default-partner`, data).then(resp => {
        return resp.data;
    });
};

export const UpdateUserData = () => {
    return api.get(`${API_URL}/admin/user/me/`).then(resp => {
        return resp.data;
    });
}

export const fetchPartnerList = (page, perPage, partnerSearchFilters) => {
    let url = `${API_URL}/admin/partners/?page=${page}&size=${perPage}`;
    if (partnerSearchFilters.searchText) {
        url = `${url}&q=${partnerSearchFilters.searchText}`;
    }
    return api.get(url).then(resp => {
        return resp.data;
    });
};

export const addPartner = (data) => {
    return api
        .post(`${API_URL}/admin/partners/`, data)
        .then(resp => {
            return resp.data;
        });
};

export const editPartner = (id, data) => {
    return api
        .put(`${API_URL}/admin/partner/${id}/`, data)
        .then(resp => {
            return resp.data;
        });
};

export const fetchPartnerById = (id) => {
    return api
        .get(`${API_URL}/admin/partner/${id}`)
        .then(resp => {
            return resp.data;
        });
};

export const mapPartnerProduct = (data) => {
    return api
        .post(`${API_URL}/admin/partners/product`, data)
        .then(resp => {
            return resp.data;
        });
};


export const unregisterPartnerProduct = (id) => {
    return api
        .put(`${API_URL}/admin/partner/product/unregister/${id}/`)
        .then(resp => {
            return resp.data;
        });
};

export const fetchPartnerProductList = (id) => {
    return api
        .get(`${API_URL}/admin/partner/${id}/products/`)
        .then(resp => {
            return resp.data;
        });
};

export const deletePartnerById = id => {
    return api.delete(`${API_URL}/admin/partner/${id}/`).then(resp => {
        return resp.data;
    });
};

export const activatePartnerById = id => {
    return api.put(`${API_URL}/admin/partner/activate/${id}/`).then(resp => {
        return resp.data;
    });
};

export const deactivatePartnerById = id => {
    return api.put(`${API_URL}/admin/partner/deactivate/${id}/`).then(resp => {
        return resp.data;
    });
};